<template>
  <v-select
    v-bind="{
      ...$attrs,
      ...commonAttrs
    }"
    v-on="$listeners"
    ref="select"
    class="x-select"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="data">
      <slot :name="scopedSlotName" v-bind="data"/>
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName"/>
    </template>
  </v-select>
</template>

<script>
import {autocompleteOff} from "@/mixins/autocomplete-off/autocomplete-off"
import {mdiChevronDown} from "@mdi/js"

export default {
  name: 'x-select',
  mixins: [autocompleteOff],
  data() {
    return {
      icons: {
        mdiChevronDown
      }
    }
  },
  computed: {
    commonAttrs() {
      return {
        autocomplete: this.attrAutocomplete,
        hideDetails: this.$attrs.hideDetails ?? 'auto',
        outlined: this.$attrs.outlined ?? true,
        clearable: this.$attrs.clearable ?? true,
        appendIcon: this.$attrs.appendIcon ?? this.icons.mdiChevronDown
      }
    }
  }
}
</script>

<style scoped>

</style>